module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-700italic.81f5786.woff";